import '@mdi/font/css/materialdesignicons.css'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    ssr: true,
    theme: {
      themes: {
        light: {
          colors: {
            primary: '#ED9052',
            secondary: '#ffffff',
          },
        },
        dark: {
          dark: true,
          colors: {
            primary: '#ED9052',
            secondary: '#ffffff',
          },
        }
      },
    }
  })
  app.vueApp.use(vuetify)
})
